import { IconWrapper } from '../runtime';
export default IconWrapper('warn-shape', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("g", [h("path", {
    "attrs": {
      "d": "M6.2521 2.02338C7.01671 0.664083 8.97379 0.664081 9.7384 2.02338L15.7422 12.0196C16.4921 13.3528 15.5145 15.0001 13.9848 15.0001H2.00486C0.475212 15.0001 -0.488216 13.3528 0.261714 12.0196L6.2521 2.02338Z",
      "fill": "#F06621"
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M8 5C8.55228 5 9 5.44772 9 6V9C9 9.55228 8.55228 10 8 10C7.44772 10 7 9.55228 7 9V6C7 5.44772 7.44772 5 8 5ZM7 12C7 11.4477 7.44772 11 8 11V11C8.55228 11 9 11.4477 9 12V12C9 12.5523 8.55228 13 8 13V13C7.44772 13 7 12.5523 7 12V12Z",
      "fill": "white"
    }
  })])]);
});